module.exports = __webpack_public_path__ + "img/ts14.a391c074.png";